import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { COLORS } from '../../constants/theme';
const PaginationContainer = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    padding: '16px 0',
});
const PageButton = styled(Button)(({ theme, isActive }) => ({
    minWidth: '40px',
    width: '40px',
    height: '40px',
    borderRadius: '4px',
    fontSize: '14px',
    fontWeight: 700,
    padding: 0,
    border: isActive ? 'none' : `1px solid ${COLORS.WHITE}`,
    backgroundColor: isActive ? COLORS.BRIGHT_YELLOW : 'transparent',
    color: isActive ? '#000000' : COLORS.WHITE,
    '&:hover': {
        backgroundColor: isActive ? COLORS.BRIGHT_YELLOW : 'rgba(255, 255, 255, 0.1)',
    },
    '&:disabled': {
        backgroundColor: isActive ? COLORS.BRIGHT_YELLOW : 'transparent',
        border: isActive ? 'none' : `1px solid ${COLORS.SLATE_GRAY}`,
        color: isActive ? '#000000' : COLORS.SLATE_GRAY,
        cursor: 'not-allowed',
    },
}));
const NavigationButton = styled(Button)({
    minWidth: 'auto',
    height: '40px',
    borderRadius: '4px',
    fontSize: '16px',
    fontWeight: 700,
    padding: '0 16px',
    border: 'none',
    backgroundColor: 'transparent',
    color: COLORS.WHITE,
    textTransform: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '&:hover': {
        backgroundColor: 'rgba(255, 215, 0, 0.1)',
    },
    '&:disabled': {
        backgroundColor: 'transparent',
        color: COLORS.SLATE_GRAY,
        cursor: 'not-allowed',
    },
});
const EllipsisText = styled(Typography)({
    color: COLORS.WHITE,
    fontSize: '14px',
    fontWeight: 500,
    minWidth: '40px',
    textAlign: 'center',
});
export default function Pagination({ currentPage, totalPages, onPageChange, maxVisiblePages = 5, disabled = false }) {
    if (totalPages <= 1) {
        return null;
    }
    const getVisiblePages = () => {
        const pages = [];
        if (totalPages <= maxVisiblePages) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        }
        else {
            const halfVisible = Math.floor(maxVisiblePages / 2);
            if (currentPage <= halfVisible + 1) {
                for (let i = 1; i <= maxVisiblePages - 1; i++) {
                    pages.push(i);
                }
                if (maxVisiblePages < totalPages) {
                    pages.push('ellipsis');
                    pages.push(totalPages);
                }
            }
            else if (currentPage >= totalPages - halfVisible) {
                pages.push(1);
                if (totalPages > maxVisiblePages) {
                    pages.push('ellipsis');
                }
                for (let i = totalPages - maxVisiblePages + 2; i <= totalPages; i++) {
                    pages.push(i);
                }
            }
            else {
                pages.push(1);
                pages.push('ellipsis');
                for (let i = currentPage - halfVisible + 1; i <= currentPage + halfVisible - 1; i++) {
                    pages.push(i);
                }
                pages.push('ellipsis');
                pages.push(totalPages);
            }
        }
        return pages;
    };
    const visiblePages = getVisiblePages();
    const hasNext = currentPage < totalPages;
    const hasPrev = currentPage > 1;
    return (_jsxs(PaginationContainer, { children: [_jsxs(NavigationButton, { onClick: () => onPageChange(currentPage - 1), sx: { visibility: hasPrev ? 'visible' : 'hidden' }, disabled: disabled, children: [_jsx(ChevronLeft, { sx: { marginTop: '1px', color: COLORS.BRIGHT_YELLOW } }), "Prev"] }), visiblePages.map((page, index) => page === 'ellipsis' ? (_jsx(EllipsisText, { children: "..." }, `ellipsis-${index}`)) : (_jsx(PageButton, { isActive: page === currentPage, onClick: () => onPageChange(page), disabled: disabled || page === currentPage, children: page }, page))), _jsxs(NavigationButton, { onClick: () => onPageChange(currentPage + 1), sx: { visibility: hasNext ? 'visible' : 'hidden' }, disabled: disabled, children: ["Next", _jsx(ChevronRight, { sx: { marginTop: '1px', color: COLORS.BRIGHT_YELLOW } })] })] }));
}
//# sourceMappingURL=Pagination.js.map